<template>
  <div class="loginbg">
    <div class="contentfrom">
      <img :src="headLogo" width="130"/>
      <H1 class="loginTitle">{{ systemName }}</H1>
      <el-card class="box-card">
        <el-form ref="login" :model="form" label-width="0" :rules="ruleLogin">
          <el-form-item style="margin-top:40px;" prop="studentId">
            <el-input placeholder="请输入学号" v-model.trim="form.studentId">
              <img src="../images/account.png" slot="prepend" width="20"/>
            </el-input>
          </el-form-item>
          <el-form-item style="margin-top:40px;" prop="password">
            <el-input placeholder="请输入密码" v-model.trim="form.password" type="password">
              <img src="../images/password.png" slot="prepend" width="20"/>
            </el-input>
          </el-form-item>
        </el-form>
        <el-button @click="login" type="primary" style="width: 100%; margin: 20px 0" round class="mt20">登录</el-button>
        <p>注：请输入学号和密码登录，未注册用户请点击下方客服按钮。</p>
        <p style="text-align: right; font-size: 10px; color: #409EFF" id="yingyuchat" @click="contactCustomerService">联系客服</p>
      </el-card>
      <el-button v-if="isXbmuBtn" @click="aiInterview" type="primary" style="width: 100%; margin: 20px 0; background: #826AF9;border: none" round class="mt20">AI模拟面试系统<i class="el-icon-right"></i></el-button>
    </div>
    
    <div class="foot">
      <p>Copyright © www.rennengda.com All Rights Reserved.</p>
    </div>
  </div>
</template>
<script>
import HttpRequest from "@/utils/request";
import {setSessionData, savePersistentStudent, savePersistentPartner, savePersistentLoginPage, loadPersistentStudent, loadPersistentPartner, loadPersistentLoginPage} from "../utils/cache";
import {getFrameMenus} from "@/assets/js/consult";
import setWechatTitle from "@/utils/setWechatTitle.js";
import { getConsultModule } from "../assets/js/application.js"

export default {
  name: "leftMenu",
  data() {
    return {
      ruleLogin: {
        studentId: [
          {required: true, message: '请输入学号', trigger: 'blur'}
        ],
        password: [
          {required: true, message: '请输入密码', trigger: 'blur'},
          {min: 6, message: '密码长度至少6位', trigger: 'blur'}
        ],
      },
      form: {
        partner: null,
        studentId: "",
        password: "",
      },
      headLogo: '',
      openOtherHomepage: '0',
      isXbmuBtn: false,
      systemName: "生涯咨询预约中心",
    };
  },

  created() {
    // 检查是否有持久化的登录凭据，有则直接跳转
    let persistentStudent = loadPersistentStudent()
    let persistentPartner = loadPersistentPartner()
    if (persistentStudent && persistentStudent.token && persistentPartner) {
      let loginPage = loadPersistentLoginPage()
      setSessionData("partner", persistentPartner)
      setSessionData("loginPage", loginPage)
      store.dispatch('setStudent', persistentStudent)
      store.dispatch('setLoginStatus', 1)
      this.getAdmin(persistentPartner, persistentStudent.token, persistentStudent.studentName)
      return
    }
    let partner = this.$route.query.partner
    if (!partner || partner === 'undefined') {
      this.$alert('登录网址不对');
    } else {
      this.form.partner = partner
      if(partner == "xbmu") {
        this.isXbmuBtn = true
        this.systemName = "AI面试亭预约"
        setWechatTitle("AI面试亭预约");
      }
      this.headLogo = 'https://sys.rennengda.com/consult/logos/head-' + partner + '.png';
      this.openOtherHomepage = this.$route.query.openOtherHomepage
    }
  },
  mounted() {
  },
  methods: {
    contactCustomerService() {
      console.log('11111')
      let partner = this.$route.query.partner
      this.$router.push("/customerService" + '?partner=' + partner)
    },
    isMobile() {
       return /Android|iPhone|iPad|iPod|Windows Phone|BlackBerry|Mobile/i.test(navigator.userAgent);
    },

    aiInterview() {
    //  if(this.isMobile()) {
    //   window.location.href = 'weixin://dl/business/?appid=wx5f666cd6b33877ae&path=pages/home/index&env_version=release';
    //  } else {
      window.location.href = 'https://growup.aminer.cn/student/login';
    //  }
    },
    getAdmin(partner, token, name) {
      let url = "/constub/gainAdminMenu";
      HttpRequest.requestFormPost(url, {partner: partner, token: token}).then((res) => {
        let admin = res.data
        if (this.openOtherHomepage !== '1' || admin.jsonSetting.save_other_homepage !== 1) {
          admin.jsonSetting.open_homepage = ""
        }
        store.dispatch('setAdmin', admin)
        // let consult_SmartPavilion = admin.jsonSetting.consult_SmartPavilion
        // let menus = getFrameMenus(consult_SmartPavilion, admin.jsonSetting.open_homepage)
        // let menus = getConsultModule(consult_SmartPavilion)
        // let r = menus[0].path
        if (name){
          // this.$router.push('/' + r + '?partner=' + partner);
          if(admin.jsonSetting.consult_SmartPavilion == 1) {
             //判断是否只有面试亭
            this.$router.push('/pavilionAppoint?' + 'partner=' + partner)
          } else {
            if(this.openOtherHomepage == 1 && admin.jsonSetting.open_homepage == 'questCenter') {
              this.$router.push('/questCenter?' + 'partner=' + partner)
            } else {
              this.$router.push('/home' + '?partner=' + partner);
            }
          }
        } else {
          this.$alert('首次登录，请先填写个人资料', {
            showClose: false,
            confirmButtonText: '继续',
            callback: action => {
              // this.$router.push('/firstPersonalData?pathfrom=' + r);
              if(admin.jsonSetting.consult_SmartPavilion == 1) {
                this.$router.push('/firstPersonalData?pathfrom=' + 'pavilionAppoint')
              } else if(this.openOtherHomepage == 1 && admin.jsonSetting.open_homepage == 'questCenter'){
                this.$router.push('/firstPersonalData?pathfrom=' + 'questCenter')
              } else{
                this.$router.push('/firstPersonalData?pathfrom=' + 'home')
              }
            }
          });
        }
      });
    },
    login() {
      this.$refs["login"].validate((valid) => {
        let partner = this.form.partner
        if (valid) {
          let url = "/constub/loginByStudentId";
          let data = {partner: partner, studentId: this.form.studentId, password: this.form.password};
          HttpRequest.requestFormPost(url, data).then((res) => {
            if (res && res.result.success) {
              setSessionData("partner", partner)
              setSessionData("logoutUrl", null);
              setSessionData("loginPage", "loginByStudentId");
              store.dispatch('setStudent', res.data)
              store.dispatch('setLoginStatus', 1)
              // 持久化登录凭据到 localStorage
              savePersistentStudent(res.data)
              savePersistentPartner(partner)
              savePersistentLoginPage("loginByStudentId")
              this.getAdmin(partner, res.data.token, res.data.studentName)
            } else {
              this.$alert(res.result.message, {
                confirmButtonText: '确定',
                showClose: false,
              });
            }
          });
        }
      })
    },
  },
};
</script>

<style scoped>
.loginbg {
  position: absolute;
  height: 100%;
  width: 100%;
  background-image: url('../images/bg.png');
  background-size: cover
}

.contentfrom {
  position: absolute;
  width: 80%;
  left: 50%;
  top: 5px;
  transform: translateX(-50%);
  text-align: center;
}

.contentfrom input {
  border: 0;
}

>>> .el-input-group__append,
>>> .el-input-group__prepend {
  border: 0;
  border-radius: 0;
  background: none;
  border-bottom: 1px solid #8d93b9;
}

>>> .el-input__inner {
  color: #8d93b9;
  background: none;
  border: 0;
  border-radius: 0;
  border-bottom: 1px solid #8d93b9;
}

.appendbtn {
  border: 1px solid #8d93b9 !important;
}

.loginTitle {
  margin: 20px 0 40px;
  color: #fff;
}

.foot {
  position: absolute;
  width: 80%;
  left: 50%;
  bottom: 28px;
  transform: translateX(-50%);
  text-align: center;
  color: #fff;
}
</style>
